import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { ReportTabsComponent } from './report-tabs.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  declarations: [ReportTabsComponent],
  exports: [ReportTabsComponent],
})
export class ReportTabsModule {
}
